import Skeleton from 'react-loading-skeleton';
import cns from 'classnames';
import S from '../../subscription/space/skeletons/SpacesPageSkeleton.module.scss';
export const SpaceListSkeleton = () => {
  const MAX_SKELETON_COUNT = 8;
  return <div className={cns(S.layout, S.skeleton_container)} data-sentry-component="SpaceListSkeleton" data-sentry-source-file="SpaceListSkeleton.tsx">
      <div className={S.grid}>
        {Array.from({
        length: MAX_SKELETON_COUNT
      }).map((_, index) => <div className={S.card} key={index}>
            <Skeleton className={S.card_image} width={'100%'} height={0} style={{
          paddingTop: '70%'
        }} />

            <Skeleton width={160} height={20} style={{
          marginTop: '19px',
          width: '100%'
        }} />
            <Skeleton width={180} height={24} style={{
          marginTop: '12px',
          width: '100%'
        }} />
            <Skeleton height={14} style={{
          marginTop: '14px',
          width: '100%'
        }} />
            <Skeleton height={38} style={{
          marginTop: '14px',
          width: '100%'
        }} />
          </div>)}
      </div>
    </div>;
};